import React, { Component, Fragment } from 'react';
import Pagination from '@mui/material/Pagination';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Select, FormControl, MenuItem, InputLabel, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { countries } from '../../common/countries';
import { isNull, setHour } from '../../utility';

export default class formFiltersPeer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // parametri per filtri ricerca
            sortField: '',
            sortType: '',
            id: '',
            deviceId: '',
            connectedAtStart: null,
            connectedAtEnd: null,
            vpnPass: '',
            country: '',
            model: '',
            platform: '',
            version: '',
            machineId: this.props.vpn.machineIdForDetail === '' ? '' : this.props.vpn.machineIdForDetail
        };

        this.onChange = this.onChange.bind(this);
    }

    /**
     * Cambia il valore di quello stato.
     * 
     * @param {*} event 
     */
    onChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name === 'sortType') {
            setTimeout(() => {
                this.sendParamsForSearch();
            }, 200);
        }
    }

    // change per le date
    setDateConnectedAtStart = (newDate) => { this.setState({ connectedAtStart: newDate }); }
    setDateConnectedAtEnd = (newDate) => { this.setState({ connectedAtEnd: newDate }); }

    // Resetta tutti i filtri
    resetFilter = () => {
        this.setState({
            sortField: '',
            sortType: '',
            id: '',
            deviceId: '',
            connectedAtStart: null,
            connectedAtEnd: null,
            vpnPass: '',
            country: '',
            model: '',
            platform: '',
            version: '',
            machineId: ''
        });

        setTimeout(() => {
            this.sendParamsForSearch('vuoto');
        }, 300);
    }

    /**
    * Se viene premuto il tasto enter (Invio) avvia una ricerca
    */
    clickEnter = (event) => {
        if (event.keyCode === 13) {
            this.sendParamsForSearch();
        }
    }

    /**
     * Invia i parametri filtro per la ricerca.
     * Se il parametro vuoto è presente, invia stringhe vuote per la ricerca.
     * 
     * @param {*} label se è vuoto, manda parametri vuoti
     */
    sendParamsForSearch = (label) => {
        if (label === 'vuoto') {
            this.props.setParamsForSearch({
                sortField: '',
                sortType: '',
                id: '',
                deviceId: '',
                connectedAtStart: null,
                connectedAtEnd: null,
                vpnPass: '',
                country: '',
                model: '',
                platform: '',
                version: '',
                machineId: ''
            });
        } else {
            this.props.setParamsForSearch({
                sortField: this.state.sortField,
                sortType: this.state.sortType,
                id: this.state.id,
                deviceId: this.state.deviceId,
                connectedAtStart: this.state.connectedAtStart === null ? '' : setHour(this.state.connectedAtStart),
                connectedAtEnd: this.state.connectedAtEnd === null ? '' : setHour(this.state.connectedAtEnd),
                vpnPass: this.state.vpnPass,
                country: this.state.country,
                model: this.state.model,
                platform: this.state.platform,
                version: this.state.version,
                machineId: this.state.machineId
            });
        }
    }

    render() {
        const { numberVpnPeer, totalPages, setChange, currentNumberPage } = this.props;
        return (
            <Fragment>
                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="id"
                            variant='standard'
                            value={this.state.id}
                            onChange={this.onChange}
                            onKeyDown={this.clickEnter}
                            label="ID Peer"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="vpnPass"
                            variant='standard'
                            value={this.state.vpnPass}
                            onChange={this.onChange}
                            onKeyDown={this.clickEnter}
                            label="Vpn Pass"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12">
                        <FormControl className='customSelect'>
                            <InputLabel>Cerca per Country</InputLabel>
                            <Select
                                name="country"
                                variant='standard'
                                value={this.state.country}
                                onChange={this.onChange}
                            >
                                {
                                    countries.map((item, k) => {
                                        return (
                                            <MenuItem key={k} value={item.value}>{item.label}</MenuItem>
                                        );
                                    })
                                }
                            </Select>
                        </FormControl>
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="machineId"
                            variant='standard'
                            value={this.state.machineId}
                            onChange={this.onChange}
                            onKeyDown={this.clickEnter}
                            label="Machine Id"
                        />
                    </div>
                </div>

                <div className="row">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="col-12 itemForSearch">
                            <DatePicker
                                variant="inline"
                                format="DD/MM/YYYY"
                                id="connectedAtStart"
                                label="Connesso da"
                                value={this.state.connectedAtStart}
                                onChange={(newValue) => this.setDateConnectedAtStart(isNull(newValue) ? null : dayjs(newValue.$d))}
                            />
                        </div>

                        <div className="col-12 itemForSearch">
                            <DatePicker
                                variant="inline"
                                id="connectedAtEnd"
                                label="Fino a"
                                value={this.state.connectedAtEnd}
                                onChange={(newValue) => this.setDateConnectedAtEnd(isNull(newValue) ? null : dayjs(newValue.$d))}
                                format="DD/MM/YYYY"
                            />
                        </div>
                    </LocalizationProvider>
                </div>

                <div className="row itemForSearch" style={{ 'marginTop': '3rem' }}>
                    <div className="col-12 text-center">
                        <button
                            className={numberVpnPeer === '10' ? "btnAround selected" : "btnAround"}
                            onClick={() => setChange({ target: { name: 'numberVpnPeer' } }, '10')}
                        > 10 </button>
                        <button
                            className={numberVpnPeer === '25' ? "btnAround selected" : "btnAround"}
                            onClick={() => setChange({ target: { name: 'numberVpnPeer' } }, '25')}
                        > 25 </button>
                        <button
                            className={numberVpnPeer === '50' ? "btnAround selected" : "btnAround"}
                            onClick={() => setChange({ target: { name: 'numberVpnPeer' } }, '50')}
                        > 50 </button>
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <Pagination
                            boundaryCount={2}
                            count={parseInt(totalPages) || 0}
                            page={parseInt(currentNumberPage)}
                            onChange={setChange}
                            color="primary"
                            showFirstButton
                            showLastButton
                            size="small"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <button className="btn btn-primary" style={{ 'margin': '10px' }} onClick={this.sendParamsForSearch}>
                            Cerca
                        </button>
                        <button className="btn btn-secondary" style={{ 'margin': '10px' }} onClick={this.resetFilter}>
                            Reset
                        </button>
                    </div>
                </div>

                <Accordion className="myAccordion">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography>Altri filtri</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography component="div">
                            <div className="row">
                                <div className="col-12 itemForSearch">
                                    <FormControl className='customSelect'>
                                        <InputLabel>Come vuoi ordinare?</InputLabel>
                                        <Select
                                            labelId="fieldOrderLabel"
                                            name="sortField"
                                            variant='standard'
                                            value={this.state.sortField}
                                            onChange={this.onChange}
                                        >
                                            <MenuItem value={'Id'}>ID</MenuItem>
                                            <MenuItem value={'DeviceId'}>Device ID</MenuItem>
                                            <MenuItem value={'ConnectedAt'}>ConnectedAt</MenuItem>
                                            <MenuItem value={'VpnPass'}>VPN Pass</MenuItem>
                                            <MenuItem value={'Country'}>Country</MenuItem>
                                            <MenuItem value={'Model'}>Model</MenuItem>
                                            <MenuItem value={'Platform'}>Platform</MenuItem>
                                            <MenuItem value={'Version'}>Version</MenuItem>
                                            <MenuItem value={'MachineId'}>Machine ID</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="col-12 itemForSearch">
                                    <FormControl disabled={this.state.sortField === ''} className='customSelect'>
                                        <InputLabel>Tipo di Ordinamento</InputLabel>
                                        <Select
                                            labelId="typeOrderLabel"
                                            name="sortType"
                                            variant='standard'
                                            value={this.state.sortType}
                                            onChange={this.onChange}
                                        >
                                            <MenuItem value={'asc'}>Crescente [A-Z]</MenuItem>
                                            <MenuItem value={'desc'}>Decrescente [Z-A]</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 itemForSearch">
                                    <TextField
                                        name="model"
                                        variant='standard'
                                        value={this.state.model}
                                        onChange={this.onChange}
                                        onKeyDown={this.clickEnter}
                                        label="Model"
                                    />
                                </div>

                                <div className="col-12 itemForSearch">
                                    <TextField
                                        name="platform"
                                        variant='standard'
                                        value={this.state.platform}
                                        onChange={this.onChange}
                                        onKeyDown={this.clickEnter}
                                        label="Platform"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 itemForSearch">
                                    <TextField
                                        name="version"
                                        variant='standard'
                                        value={this.state.version}
                                        onChange={this.onChange}
                                        onKeyDown={this.clickEnter}
                                        label="Version"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 itemForSearch">
                                    <TextField
                                        name="deviceId"
                                        variant='standard'
                                        value={this.state.deviceId}
                                        onChange={this.onChange}
                                        onKeyDown={this.clickEnter}
                                        label="Device ID"
                                    />
                                </div>
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Fragment>
        )
    }
}